<template>
	<div class="expandable-area" :class="{closed:status.imageClosed}" >
		<h3 class="expandable-title" @click="statusToggle('imageClosed')">Product image
			<info-icon>
				Allows you to set an image to be shown alongside your product name and price in an order form.
				<div style="margin-top: 10px">
					<img alt="" width="300" :src="require('@/assets/img/product-img-sample.png')" />
				</div>
			</info-icon>
			<inline-svg class="arrow" :src="require('@/assets/img/chevron-top.svg')" />
		</h3>

		<div class="area-content product-image-panel" >
			<div class="img-wrapper" @click="popupOpen=true">
				<v-button class="remove" v-if="product.image_url"
				          @click.stop="product.image_url=''"
				          :icon="require('@/assets/img/delete_icon.svg')" slim flat
				          v-tippy content="Remove image" />
				<span class="change">Change...</span>
				<img v-if="product.image_url" alt="" :src="product.image_url" />
				<img  v-else alt="" src="//img.funnelish.com/default/default-image.svg?h=300&auto=compress,format&fit=clip" />
			</div>
			<select-image-popup v-if="popupOpen" :funnel-id="funnelId"
			                    @imageChoosed="product.image_url=$event.url" @closePopup="popupOpen=false"  />
			<div class="flex"></div>
		</div>
	</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import SelectImagePopup from "@/modules/page-editor/src/components/popups/SelectImagePopup";
export default {
	name: "product-image-panel",
	components: {SelectImagePopup, InfoIcon, VButton},
	props:['product'],
	data() {
		return {
			status: {
				imageClosed: false,
			},
			popupOpen: false,
		}
	},
	computed:{
		funnelId(){
			return parseInt(this.product.funnel_id);
		},
	},
	methods:{
		statusToggle(key){
			this.status[key] = !this.status[key];
			localStorage.setItem('product.'+key, this.status[key]);
		},
	},
	created() {
		this.status.imageClosed = localStorage.getItem('product.imageClosed')==="true";
	}
}
</script>

<style lang="scss" >
.product-image-panel {
	.img-wrapper{
		.remove{
			&:hover {
				background: rgb(255 190 190) !important;
			}
			svg {
				margin: 0;
				path {
					fill: red;
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.brdr_content_title {
	display: flex;
}
.product-image-panel {
	display: flex;
	flex-direction: row;
	.img-wrapper {
		border: 1px dashed $sharp-blue;
		border-radius: 3px;
		width: 90px;
		height: 90px;
		line-height: 90px;
		cursor: pointer;
		position: relative;

		.remove {
			background: transparent;
			position: absolute;
			top: 3px;
			width: auto;
			height: auto;
			right: 3px;
			padding: 5px;
			z-index: 5;
		}
		.change {
			display: inline-block;
			position: absolute;
			width: 100%;
			height: 100%;
			text-align: center;
			z-index: 2;
			color: whitesmoke;
			transition: all .2s ease-in-out;
			opacity: 0;
		}
		&:after {
			transition: all .2s ease-in-out;
			background: rgba(0, 0, 0, 0.35);
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
		}
		&:hover {
			border: 1px solid rgba(0, 0, 0, 0.35);
			.change {
				opacity: 1;
			}
			&:after {
				opacity: 1;
			}
		}
		img {
			height: 100%;
			width: 100%;
			object-fit: scale-down;
		}
	}
	.button {
		display: flex;
		width: 80px;
		height: 80px;
		flex: 0;
	}
}
</style>
